// extracted by mini-css-extract-plugin
module.exports = {"Year":"Year_Year__3LU80","Year_portfolio":"Year_Year_portfolio__2EX1x","Year__Letters":"Year_Year__Letters__1OLMu","Year__Letters_portfolio":"Year_Year__Letters_portfolio__utbi0"};